// AboutUs.js

import React from 'react';
import styles from "./AboutUs.module.scss";
import Image from 'next/image';
import SlowLoad from '@/app/wrappers/Slowload';

export default function AboutUs() {

  return (
    <div className={styles.aboutParent} id="about-us">
      <SlowLoad>
        <div className={styles.inner}>
          <div className={styles.aboutBody}>
            <div className='row d-flex align-items-center gx-4'>
              <div className='col-lg-5 mb-4 mb-lg-0"'>
                <h2>About Us</h2>
                At <strong>Altra Edge</strong>, we help brands connect with the high-intent customers, expand their reach, and increase sales, all through targeted, performance-based marketing and measurable results.
              </div>
              <div className={`col ${styles.imageWrapper}`} >
                <Image
                  className={styles.aboutImg}
                  alt="Laptop displaying data charts and graphs"
                  width={500}
                  height={500}
                  style={{ width: "100%", height: "auto", borderRadius: "22px", maxWidth: "500px" }}
                  src="/imgs/laptop.jpg"
                />
              </div>
            </div>
          </div>
        </div>
      </SlowLoad>
    </div>
  );
}
